<template>
  <div class="login-page">
    <div class="login-card card">
      <img src="../assets/logo.png" alt="El Shaday" class="login-logo" />
      <h1 class="login-title">Acamp Check-in</h1>
      <p class="login-subtitle">Entre com sua conta de administrador</p>

      <form @submit.prevent="handleSubmit" class="login-form">
        <div class="form-group">
          <label class="label" for="email">Email</label>
          <input id="email" class="input" type="email" v-model="email" placeholder="admin@acamp.local" autocomplete="email" required />
        </div>
        <div class="form-group">
          <label class="label" for="password">Senha</label>
          <input id="password" class="input" type="password" v-model="password" placeholder="••••••••" autocomplete="current-password" required />
        </div>

        <button class="btn-primary login-btn" type="submit" :disabled="loading">
          <span v-if="!loading">Entrar</span>
          <span v-else>Entrando...</span>
        </button>
      </form>

      <p class="login-hint" v-if="hint">Em dev, registre via API: <code>POST /auth/register</code></p>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from '../stores/auth'

export default {
  name: 'LoginPage',
  data() {
    return {
      email: '',
      password: '',
      loading: false,
      hint: true
    }
  },
  computed: {
    authStore() { return useAuthStore() }
  },
  mounted() {
    if (this.authStore.isAuthenticated) {
      this.$router.replace('/')
    }
  },
  methods: {
    async handleSubmit() {
      this.loading = true
      try {
        await this.authStore.login(this.email, this.password)
        this.$toast.open({ message: 'Bem-vindo(a)!', type: 'success', position: 'top-right', duration: 3000 })
        this.$router.push('/')
      } catch (err) {
        const msg = err.response?.data?.message || 'Erro ao fazer login'
        this.$toast.open({ message: msg, type: 'error', position: 'top-right', duration: 4000 })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-base);
  background: linear-gradient(135deg, var(--color-bg-body) 0%, #d4d4d4 100%);
}
.login-card {
  width: 100%;
  max-width: 400px;
  padding: var(--spacing-xl);
  text-align: center;
}
.login-logo {
  width: 72px;
  height: 72px;
  border-radius: var(--radius-circle);
  object-fit: cover;
  margin-bottom: var(--spacing-base);
}
.login-title {
  font-size: var(--text-xl);
  font-weight: 700;
  color: var(--color-text-primary);
  margin-bottom: var(--spacing-sm);
}
.login-subtitle {
  font-size: var(--text-sm);
  color: var(--color-text-muted);
  margin-bottom: var(--spacing-lg);
}
.login-form {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-base);
  text-align: left;
  margin-bottom: var(--spacing-base);
}
.form-group {
  display: flex;
  flex-direction: column;
}
.login-btn {
  justify-content: center;
  margin-top: var(--spacing-sm);
}
.login-hint {
  font-size: var(--text-xs);
  color: var(--color-text-muted);
  margin-top: var(--spacing-md);
}
.login-hint code {
  background: var(--color-bg-hover);
  padding: 2px 6px;
  border-radius: var(--radius-sm);
  font-family: monospace;
}
</style>
